import { Components, Theme } from '@mui/material'

export const MuiBreadcrumbs: Components<Omit<Theme, 'components'>>['MuiBreadcrumbs'] = {
  defaultProps: {
    // TODO - proper separator icon
  },
  styleOverrides: {
    li: ({ theme }) => ({
      ...theme.typography['futureTheme.body-medium'],
      borderRadius: theme.shape['futureTheme.radius-sm'],
      color: theme.palette.futureTheme.text.subtle,
      '&:hover:has(a)': {
        backgroundColor: theme.palette.futureTheme.bg.interactive.hover,
      },

      '&:last-child': {
        color: theme.palette.futureTheme.text.default,
      },

      '& a, & .MuiTypography-root': {
        padding: theme.spacing(0, 1),
        color: 'inherit',
        textDecoration: 'none',
      },
    }),
    separator: ({ theme }) => ({
      margin: theme.spacing(0, 1.5),
      color: theme.palette.futureTheme.fg.subtle,
    }),
  },
}
